import React from "react";
import FaqSlideBody from "./FaqSlideBody";

function FaqPage({ spotify }) {
  return (
    <div className="faq-page" style={{ padding: "24px" }}>
      <FaqSlideBody spotify={spotify} />
    </div>
  );
}

export default FaqPage;